// Crop Condition Handle Submit
export const cropConditionHandleSubmit = (items) => {

  // Items should break out if anything is missing in even one column
  for (let i = 0; i < items.length; i++) {
      // Check if all the required fields are available
      if (!items[i].district || !items[i].district_id || !items[i].year || !items[i].cotton_picking_current_year || !items[i].cotton_picking_previous_year || !items[i].avg_yield_per_acre_current_year || !items[i].avg_yield_per_acre_previous_year || !items[i].avg_ball_no || !items[i].crop_condition || (!items[i].pest_attacked_controlled && !items[i].pest_attacked_severe)) {
           // console.log("Missing items")
          return { message: "Missing items." };
      }
  }

  for(let i = 0; i < items.length; i++){
    
  }

  // Crop conditions final array
  const submitCropConditions = [];
  
  for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const cropCondition = {
          district: item.district,
          year: item.year,
          district_id: item.district_id,
          avg_ball_no: parseInt(item.avg_ball_no),
          crop_condition: item.crop_condition
      };

      // Array for pest attacked
      const pest_attacked = [];

      // Convert pest attacked to array because we will receive a string
      if (typeof item.pest_attacked_controlled === 'string') {
          const pestsDataControlled = item.pest_attacked_controlled.split(',');
          for (let j = 0; j < pestsDataControlled.length; j++) {
              pest_attacked.push({
                  pest_name: pestsDataControlled[j].trim(),
                  number_attacked: "Controlled"
              });
          }
      }

      // Convert pest attacked to array because we will receive a string
      if (typeof item.pest_attacked_severe === 'string') {
          const pestsDataSevere = item.pest_attacked_severe.split(',');
          for (let j = 0; j < pestsDataSevere.length; j++) {
              pest_attacked.push({
                  pest_name: pestsDataSevere[j].trim(),
                  number_attacked: "Severe"
              });
          }
      }

      // Cotton picking align with the right format
      const cotton_picking = {
          curr_year: parseInt(item.cotton_picking_current_year),
          prev_year: parseInt(item.cotton_picking_previous_year)
      };

      // Cotton average yield per acre with the right format
      const avg_yield_per_acre = {
          curr_year: parseInt(item.avg_yield_per_acre_current_year),
          prev_year: parseInt(item.avg_yield_per_acre_previous_year)
      };

      // Add all the additional key-value pairs
      cropCondition.pest_attacked = pest_attacked;
      cropCondition.cotton_picking = cotton_picking;
      cropCondition.avg_yield_per_acre = avg_yield_per_acre;

      // Push the crop condition to the array
      submitCropConditions.push(cropCondition);
  }

 // console.log(submitCropConditions)
  return submitCropConditions;
};
